import React, { Component } from 'react';
import { SHOP_URL, SHOP_NAME } from '../../constants';

class FormBuilder extends Component {
	constructor() {
		super();
	}

	matchSlotToTypes = (slots, typeOptions, selected_size) => {
		return slots.map((slot, index) => {
			const typeOption = typeOptions.filter(type => slot.product.product_id === type.product_id && slot.product.shopify_details.variant.title === selected_size
			)
			if (typeOption[0]) {
				return {
					index: index,
					slotId: slot.id,
					quantity: typeOption[0].quantity
				}

			} else {
				return {
					index: index,
					slotId: slot.id,
					quantity: 0
				}
			}

		})
	}
	componentDidMount() {
		this.matchSlotToTypes(this.props.slots, this.props.typeOptions, this.props.selectedSize.size)
	}
	render() {
		return (
			<form action={`https://recurringcheckout.com/s/${this.props.apiCreds.shopName}/checkout/recurring_product?shop_url=${this.props.apiCreds.shopUrl}`} method="POST">
				<input type="hidden" name="form_type" value="product" />
				<input type="hidden" name="utf8" value="✓" />
				<input type="hidden" name="bold-ro__selector_radio_button" value="3" />
				<input type="hidden" name="frequency_num" value="1" />
				<input type="hidden" name="frequency_type" value="3" />
				<input type="hidden" name="frequency_type_text" value="Month(s)" />
				<input type="hidden" name="group_id" value={this.props.selectedQuantityOption.productGroupId} />
				<input type="hidden" name="discounted_price" value={this.props.selectedProductVariant.variantPrice} />
				<input type="hidden" name="_ro_discount_percentage" value="0" />
				<input type="hidden" name="_ro_unformatted_price" value={this.props.selectedProductVariant.variantPriceUnformatted} />
				<input type="hidden" name="quantities[0]" value="1" />
				<input type="hidden" name="product_id[0]" value={this.props.selectedQuantityOption.productId} />
				<input type="hidden" name="variant_id[0]" value={this.props.selectedProductVariant.variantId.toString()} />
				<input type="hidden" name="note" value="" />
				<input type="hidden" name="shopify_customer_id" value="" />
				<input type="hidden" name="email" value="" />
				<input type="hidden" name="address1" value="" />
				<input type="hidden" name="address2" value="" />
				<input type="hidden" name="city" value="" />
				<input type="hidden" name="company" value="" />
				<input type="hidden" name="country" value="" />
				<input type="hidden" name="first_name" value="" />
				<input type="hidden" name="last_name" value="" />
				<input type="hidden" name="phone" value="" />
				<input type="hidden" name="province" value="" />
				<input type="hidden" name="zip" value="" />
				{this.matchSlotToTypes(this.props.slots, this.props.typeOptions, this.props.selectedSize.size).map(slot => {
					return (
						<React.Fragment>
							<input type="hidden" name={`properties[_ro_subscription_box_choices][${slot.index}][slot]`} value={slot.slotId} />
							<input type="hidden" name={`properties[_ro_subscription_box_choices][${slot.index}][quantity]`} value={slot.quantity} />
						</React.Fragment>
					)
				})}

				<input type="hidden" name="properties[_ro_timestamp]" value={new Date().getTime()} />
				<input type="submit" className="button" value="checkout" />
			</form>
		)
	}
}

export default FormBuilder;


